import { Injectable, OnDestroy } from '@angular/core';
import { WindowRef } from '@helpers/windowref';
import { CanvasInputMode, CanvasInputModeService } from './canvas-input-mode.service';
import { IcreateWindowReferenceService } from './icreate-window-reference.service';
import { PathService } from './path.service';

@Injectable({ providedIn: 'root' })
export class MoveCanvasService implements OnDestroy {
    private moveCanvasMouseMove: (e: MouseEvent) => void;
    private moveCanvasMouseUp: (e: MouseEvent) => void;
    private moveCanvasMouseDown: (e: MouseEvent) => void;

    previousCanvasMode: CanvasInputMode;
    canvasIsMoving: boolean = false;

    constructor(
        private windowElements: IcreateWindowReferenceService,
        private tools: CanvasInputModeService,
        private winRef: WindowRef,
        private inputModeService: CanvasInputModeService,
        private pathService: PathService
    ) {}

    init(): void {
        this.bindMoveCanvasEvents();
    }

    ngOnDestroy(): void {
        this.unbindMoveCanvasEvents();
    }

    public moveCanvas(offsetX, offsetY) {
        const editor = this.windowElements.getEditorContainer();
        editor.style.top = editor.offsetTop + offsetY + 'px';
        editor.style.left = editor.offsetLeft + offsetX + 'px';
    }

    setCanvasIsMoving(isMoving: boolean) {
        this.canvasIsMoving = isMoving;
    }

    startMoveCanvas() {
        if (this.inputModeService.getMode() == CanvasInputMode.PATH) {
            this.pathService.finishPath();
        }
        if (this.canvasIsMoving) return;
        this.previousCanvasMode = this.inputModeService.getMode();
        this.inputModeService.setMode(CanvasInputMode.MOVE_CANVAS);
    }

    stopMoveCanvas() {
        this.inputModeService.setMode(this.previousCanvasMode);
    }

    private bindMoveCanvasEvents() {
        let pos1 = 0,
            pos2 = 0,
            pos3 = 0,
            pos4 = 0;
        const editor: HTMLElement = this.windowElements.getEditorContainer();

        let isMovingCanvas = false;

        this.moveCanvasMouseDown = e => {
            if (this.tools.getMode() == CanvasInputMode.MOVE_CANVAS) {
                e.preventDefault();
                pos3 = e.clientX;
                pos4 = e.clientY;
                isMovingCanvas = true;
            }
        };

        this.moveCanvasMouseMove = e => {
            if (isMovingCanvas) {
                e.preventDefault();
                pos1 = pos3 - e.clientX;
                pos2 = pos4 - e.clientY;
                pos3 = e.clientX;
                pos4 = e.clientY;

                this.moveCanvas(-pos1, -pos2);
            }
        };

        this.moveCanvasMouseUp = e => {
            isMovingCanvas = false;
        };

        this.winRef.nativeWindow.addEventListener('mouseup', this.moveCanvasMouseUp);
        this.winRef.nativeWindow.addEventListener('mousemove', this.moveCanvasMouseMove);
        editor.addEventListener('mousedown', this.moveCanvasMouseDown);
    }

    private unbindMoveCanvasEvents() {
        this.winRef.nativeWindow.removeEventListener('mouseup', this.moveCanvasMouseUp);
        this.winRef.nativeWindow.removeEventListener('mousemove', this.moveCanvasMouseMove);
        this.windowElements.getEditorContainer().removeEventListener('mousedown', this.moveCanvasMouseDown);
    }
}
